import { IcecreamIllustration } from '@/illustrations';

export const NoResult = () => {
  return (
    <div className='flex h-full w-full flex-col items-center'>
      <div className='flex flex-col space-y-4'>
        <div className='flex w-full justify-center'>
          <IcecreamIllustration />
        </div>
        <h3 className='text-md text-center font-semibold'>Hoppsan! Här ser det tomt ut.</h3>
        <p className='text-center'>
          Du verkar inte ha några sparade bokmärken för denna flik. Du kan enkelt spara nuvarande filtrering till ett
          bokmärke genom att fylla i namn för din filtrering och sedan klicka på &quot;Spara bokmärke&quot; eller tryck
          &quot;Enter&quot;.
        </p>
      </div>
    </div>
  );
};
